import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

const BlogPostTopicsLinks = ({ topics, urlPrefix }) =>
    topics?.map((topic, i) => [
        i > 0 && ", ",
        <Link
            to={`${urlPrefix}/topic/${topic.slug}/`}
            key={topic.slug}
            title={`See all our ${topic.name} posts`}
        >
            {topic.name}
        </Link>,
    ]);

BlogPostTopicsLinks.propTypes = {
    topics: PropTypes.arrayOf(
        PropTypes.shape({
            slug: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ),
};

export default BlogPostTopicsLinks;
